import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  style: {"background":"#fff","overflow":"hidden"},
  class: "rounded-lg d-flex align-center justify-space-between mt-2 pa-1"
}
const _hoisted_2 = { style: {"width":"20%"} }
const _hoisted_3 = { style: {"width":"30%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_ConnectorsTable = _resolveComponent("ConnectorsTable")!

  return (_openBlock(), _createBlock(_component_v_row, {
    "no-gutters": "",
    class: "mb-3"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_select_filled, {
                modelValue: _ctx.activeTab,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
                items: _ctx.types,
                label: "Type",
                "hide-details": "",
                density: "compact",
                "item-title": "text"
              }, {
                item: _withCtx(({ props, item }) => [
                  (
                                    item.raw.divider || (item.raw.props && item.raw.props.divider)
                                )
                    ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                    : (
                                    item.raw.header || (item.raw.props && item.raw.props.header)
                                )
                      ? (_openBlock(), _createBlock(_component_v_list_subheader, { key: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.raw.header), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({ key: 2 }, props, {
                          value: item.value,
                          class: "text-capitalize"
                        }), null, 16, ["value"]))
                ]),
                _: 1
              }, 8, ["modelValue", "items"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_text_field_filled, {
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                "append-inner-icon": "$search",
                clearable: "",
                "onClick:clear": _cache[2] || (_cache[2] = ($event: any) => (_ctx.search = '')),
                label: "Rechercher",
                "hide-details": ""
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          (_ctx.loadingConnectors || _ctx.loadingConnectedBankAccounts)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "d-flex align-center justify-center py-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_progress_circular, {
                        indeterminate: "",
                        size: "64",
                        color: "primary"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (!_ctx.hasFilteredConnections)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 1,
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex align-center justify-center py-3"
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode(" Aucun connecteur trouvé ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
          _createVNode(_component_ConnectorsTable, {
            connectedBankAccounts: _ctx.filteredConnectedBankAccounts,
            connectors: _ctx.filteredConnectors,
            companyId: _ctx.companyId,
            displayAddConnectorCard: true,
            onUpdateProfile: _cache[3] || (_cache[3] = (authValues) => _ctx.upsertSetting(authValues))
          }, null, 8, ["connectedBankAccounts", "connectors", "companyId"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}